<app-bien-agricole-form
  *ngIf="propertyType.code === 'AGR'"
  [bienAgricole]="characteristics.bienAgricole"
  [constructionYear]="characteristics.constructionYear"
  (bienAgricoleChanged)="onBienAgricoleChanged($event)"
  (constructionYearChanged)="onConstructionYearChanged($event)"
></app-bien-agricole-form>

<app-appartement-form
  *ngIf="propertyType.code === 'APP'"
  [appartement]="characteristics.appartement"
  [constructionYear]="characteristics.constructionYear"
  (appartementChanged)="onAppartementChanged($event)"
  (constructionYearChanged)="onConstructionYearChanged($event)"
></app-appartement-form>

<app-garage-form
  *ngIf="propertyType.code === 'GAR'"
  [garage]="characteristics.garage"
  [constructionYear]="characteristics.constructionYear"
  (garageChanged)="onGarageChanged($event)"
  (constructionYearChanged)="onConstructionYearChanged($event)"
></app-garage-form>

<app-immeuble-form
  *ngIf="propertyType.code === 'IMM'"
  [immeuble]="characteristics.immeuble"
  [constructionYear]="characteristics.constructionYear"
  (immeubleChanged)="onImmeubleChanged($event)"
  (constructionYearChanged)="onConstructionYearChanged($event)"
></app-immeuble-form>

<app-maison-form
  *ngIf="propertyType.code === 'MAI'"
  [maison]="characteristics.maison"
  [constructionYear]="characteristics.constructionYear"
  (maisonChanged)="onMaisonChanged($event)"
  (constructionYearChanged)="onConstructionYearChanged($event)"
></app-maison-form>

<app-terrain-form
  *ngIf="propertyType.code === 'TER'"
  [terrain]="characteristics.terrain"
  [constructionYear]="characteristics.constructionYear"
  (terrainChanged)="onTerrainChanged($event)"
  (constructionYearChanged)="onConstructionYearChanged($event)"
></app-terrain-form>

<app-bien-viticole-form
  *ngIf="propertyType.code === 'VIG'"
  [bienViticole]="characteristics.bienViticole"
  [constructionYear]="characteristics.constructionYear"
  (bienViticoleChanged)="onBienViticoleChanged($event)"
  (constructionYearChanged)="onConstructionYearChanged($event)"
></app-bien-viticole-form>

<app-local-activite-form
  *ngIf="propertyType.code === 'LAC'"
  [localActivite]="characteristics.localActivite"
  [constructionYear]="characteristics.constructionYear"
  (localActiviteChanged)="onLocalActiviteChanged($event)"
  (constructionYearChanged)="onConstructionYearChanged($event)"
></app-local-activite-form>
